// Cached regular expressions for matching named param parts and splatted
// parts of route strings.
const ESCAPE_PEG_EXP = /[\-{}\[\]+?.,\\\^$|#\s]/g;
const NAMED_PARAM = /(\(\?)?:\w+/g;
const OPTIONAL_PARAM = /\((.*?)\)/g;
const SPLAT_PARAM = /\*\w+/g;

// Cached regex for stripping a leading hash/slash and trailing space.
const ROUTE_STRIPPER = /^[#\/]|\s+$/g;

// Cached regex for removing a trailing slash.
const TRAILING_SLASH = /\/$/;

export default class Router {

    constructor(options) {
        this.options = options || {};

        let routes = this.options.routes;
        this.matched = false;

        if (routes) {
            let route,
                keys = Object.keys(routes);

            // Bind all defined routes.
            while (typeof (route = keys.shift()) !== 'undefined') {
                if (this.matched) {
                    break;
                }

                this.route(route, routes[route]);
            }
        }
    }

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    extractParameters(route, fragment) {
        return route.exec(fragment).slice(1).map((param) => {
            return param ? decodeURIComponent(param) : null;
        });
    }

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    routeToRegExp(route) {
        route = route.replace(ESCAPE_PEG_EXP, '\\$&')
            .replace(OPTIONAL_PARAM, '(?:$1)?')
            .replace(NAMED_PARAM, (match, optional) => {
                return optional ? match : '([^/?]+)';
            })
            .replace(SPLAT_PARAM, '([^?]*?)');

        return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    }

    // Manually bind a single named route to a callback. For example:
    //
    //   router.route('search/:query/p:num', 'search', function(query, num) {
    //     ...
    //   });
    route(route, name, callback) {
        let fragment = window.location.pathname.replace(ROUTE_STRIPPER, '').replace(TRAILING_SLASH, '');

        if (!(route instanceof RegExp)) {
            route = this.routeToRegExp(route);
        }

        if (typeof name === 'function') {
            callback = name;
            name = '';
        }

        if (!callback) {
            callback = this.options[name];
        }

        if (route.test(fragment) && typeof callback === 'function') {
            this.matched = true;
            callback.apply(this, this.extractParameters(route, fragment));
        }

        return this;
    }
}



/** WEBPACK FOOTER **
 ** ./frontend/js/utils/router.js
 **/